import AddAReview from "../AddAReview/AddAReview";
import ServiceReviews from "../ServiceReviews/ServiceReviews";

const ServiceReviewSection = () => {
  return (
    <div>
      <AddAReview />
      <ServiceReviews />
    </div>
  );
};

export default ServiceReviewSection;
